"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProjectsProviderValue = void 0;
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const ICCanisterUtils_1 = require("src/hello_assets/src/util/ICCanisterUtils");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const typescriptAddons_1 = require("src/hello_assets/src/util/typescriptAddons");
const ActorsProvider_1 = require("src/hello_assets/src/components/system/actor/ActorsProvider");
const AnalyticsStoreRestApi_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/AnalyticsStoreRestApi");
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
const getAnalyticsReducerApiPromise = async (projectApiKey, managementActor) => {
    try {
        const getAnalyticsReducerApisResult = await managementActor.getAnalyticsReducerApis(ActorsProvider_1.ACTOR_SDK_VERSION, projectApiKey);
        if ((0, ICCanisterUtils_1.isICRequestOk)(getAnalyticsReducerApisResult)) {
            const analyticsReducers = getAnalyticsReducerApisResult.ok;
            const accessToken = analyticsReducers.accessToken;
            const principals = lodash_1.default.compact(lodash_1.default.map(analyticsReducers.apis, (api) => {
                const firstApiMethodName = (0, ICCanisterUtils_1.getICFirstKey)(api);
                return (0, ICCanisterUtils_1.getSharedFunctionDataPrincipal)(api[firstApiMethodName]);
            }));
            if (!!process.env.IS_TEST_SERVER) {
                console.log(`getAnalyticsReducerApiPromise[${projectApiKey}] principals`, principals, lodash_1.default.map(principals, v => v.toText()));
            }
            const hasUndefinedPrincipals = lodash_1.default.size(principals) !== lodash_1.default.size(analyticsReducers.apis);
            if (hasUndefinedPrincipals) {
                return [projectApiKey, undefined, new Error("one of the principals not found in analyticsReducers")];
            }
            return [projectApiKey, {
                    projectApiKey: projectApiKey,
                    principals: principals,
                    accessToken: accessToken
                }, undefined];
        }
        else if ((0, ICCanisterUtils_1.isICRequestErr)(getAnalyticsReducerApisResult)) {
            const error = getAnalyticsReducerApisResult.err;
            //fixme finish UI to handle following errors
            if ((0, typescriptAddons_1.hasOwnProperty)(error, "notAccess")) {
                return [projectApiKey, undefined, new Error("notAccess")];
            }
            else if ((0, typescriptAddons_1.hasOwnProperty)(error, "notFound")) {
                return [projectApiKey, undefined, new Error("notFound")];
            }
            else if ((0, typescriptAddons_1.hasOwnProperty)(error, "temporarilyUnavailable")) {
                return [projectApiKey, undefined, new Error("temporarilyUnavailable")];
            }
        }
    }
    catch (e) {
        return [projectApiKey, undefined, e];
    }
    return [projectApiKey, undefined, new Error("unknown")];
};
const getProjectsDataFromViews = async (views, managementActor) => {
    //тут из вьюшек получаем данные API и пустой стейт
    const promises = [];
    lodash_1.default.each(views, projectView => {
        const projectApiKey = projectView.projectApiKey;
        promises.push(getAnalyticsReducerApiPromise(projectApiKey, managementActor));
    });
    const promiseAllResult = await Promise.all(promises);
    const projectData = lodash_1.default.map(promiseAllResult, (promiseResult, idx) => {
        const [projectApiKey, promiseValue, error] = promiseResult;
        return {
            view: views[idx],
            api: promiseValue,
            state: { hasData: false },
            error: error
        };
    });
    return projectData;
};
const fillProjectsDataWithProjectState = async (projectsData, getAnalyticsStoreActor) => {
    //тут данные дополняем стейтом
    const promises = [];
    lodash_1.default.each(projectsData, (projectData) => {
        promises.push(new Promise(async (resolve) => {
            if (projectData.api) {
                const getActorResult = await getActorFromProjectAnalyticsReducerApiData(getAnalyticsStoreActor, projectData.api, projectData.error);
                if (getActorResult.isError) {
                    projectData.error = getActorResult.error;
                    projectData.state.hasData = false;
                    resolve(projectData);
                    return;
                }
                else {
                    if (getActorResult.actors) {
                        try {
                            const projectHasData = await AnalyticsStoreRestApi_1.AnalyticsStoreRestApi.isAnyProjectAnalytics(getActorResult.actors, projectData.api.accessToken);
                            projectData.error = undefined;
                            projectData.state.hasData = projectHasData;
                            resolve(projectData);
                            return;
                        }
                        catch (e) {
                            projectData.error = e;
                            projectData.state.hasData = false;
                            resolve(projectData);
                            return;
                        }
                    }
                }
            }
            projectData.error = projectData.error || new Error("temporarilyUnavailable: no api or actor");
            projectData.state.hasData = false;
            resolve(projectData);
        }));
    });
    const promiseAllResult = await Promise.all(promises);
    return promiseAllResult;
};
const getActorFromProjectAnalyticsReducerApiData = async (getAnalyticsStoreActor, api, error) => {
    if (api) {
        const analyticsStoreActors = [];
        for (let i = 0; i < api.principals.length; i++) {
            const principal = api.principals[i];
            const analyticsStoreActor = await getAnalyticsStoreActor(principal.toText());
            if (analyticsStoreActor != undefined) {
                analyticsStoreActors.push(analyticsStoreActor);
            }
            else {
                const result = {
                    actors: undefined,
                    accessToken: undefined,
                    error: new Error(`Could not get actor for AnalyticsStore "${principal.toText()}"`),
                    isError: true
                };
                // @ts-ignore
                return result;
            }
        }
        if (analyticsStoreActors.length > 0 && api.accessToken) {
            return {
                actors: analyticsStoreActors,
                actorPrincipals: api.principals,
                accessToken: api.accessToken,
                error: undefined,
                isError: false
            };
        }
    }
    if (error) {
        const result = {
            actors: undefined,
            accessToken: undefined,
            error: error,
            isError: true
        };
        // @ts-ignore
        return result;
    }
    const result = {
        actors: undefined,
        accessToken: undefined,
        error: new Error("unknown error"),
        isError: true
    };
    // @ts-ignore
    return result;
};
function useProjectsProviderValue() {
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const actorsContext = (0, ActorsProvider_1.useActorsContext)();
    const isMounted = (0, isMounted_1.default)();
    const createProject = (0, react_1.useCallback)(async (projectName) => {
        const managementActor = await actorsContext.getManagementActor();
        if (managementActor) {
            const createProjectResult = await managementActor.createProject(projectName);
            if ((0, ICCanisterUtils_1.isICRequestOk)(createProjectResult)) {
                const createdProjectApiKey = createProjectResult.ok;
                const getParticipantProjectsResult = await managementActor.getParticipantProjects();
                if ((0, ICCanisterUtils_1.isICRequestOk)(getParticipantProjectsResult)) {
                    const projectData = await getProjectsDataFromViews(getParticipantProjectsResult.ok, managementActor)
                        .then(value => {
                        return fillProjectsDataWithProjectState(value, actorsContext.getAnalyticsStoreActor);
                    });
                    if (isMounted()) {
                        setProjectsState({
                            inProgress: false,
                            loaded: true,
                            data: projectData,
                            error: undefined,
                            isError: false
                        });
                    }
                    return createdProjectApiKey;
                }
                else if ((0, ICCanisterUtils_1.isICRequestErr)(getParticipantProjectsResult)) {
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(getParticipantProjectsResult);
                    throw new ICCanisterUtils_1.ICRestError(errorName);
                }
            }
            else if ((0, ICCanisterUtils_1.isICRequestErr)(createProjectResult)) {
                const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(createProjectResult);
                throw new ICCanisterUtils_1.ICRestError(errorName);
            }
        }
        throw new ICCanisterUtils_1.ICRestError("unknown error");
    }, [actorsContext.getManagementActor, actorsContext.getAnalyticsStoreActor]);
    const renameProject = (0, react_1.useCallback)(async (projectApiKey, projectName) => {
        const managementActor = await actorsContext.getManagementActor();
        if (managementActor) {
            const updateProjectNameResult = await managementActor.updateProjectName(projectApiKey, projectName);
            if ((0, ICCanisterUtils_1.isICRequestOk)(updateProjectNameResult)) {
                const getParticipantProjectsResult = await managementActor.getParticipantProjects();
                if ((0, ICCanisterUtils_1.isICRequestOk)(getParticipantProjectsResult)) {
                    const projectData = await getProjectsDataFromViews(getParticipantProjectsResult.ok, managementActor)
                        .then(value => {
                        return fillProjectsDataWithProjectState(value, actorsContext.getAnalyticsStoreActor);
                    });
                    if (isMounted()) {
                        setProjectsState({
                            inProgress: false,
                            loaded: true,
                            data: projectData,
                            error: undefined,
                            isError: false
                        });
                    }
                    return projectApiKey;
                }
                else if ((0, ICCanisterUtils_1.isICRequestErr)(getParticipantProjectsResult)) {
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(getParticipantProjectsResult);
                    throw new ICCanisterUtils_1.ICRestError(errorName);
                }
            }
            else if ((0, ICCanisterUtils_1.isICRequestErr)(updateProjectNameResult)) {
                const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(updateProjectNameResult);
                throw new ICCanisterUtils_1.ICRestError(errorName);
            }
        }
        throw new ICCanisterUtils_1.ICRestError("unknown error");
    }, [actorsContext.getManagementActor, actorsContext.getAnalyticsStoreActor]);
    const fetchAllProjects = (0, react_1.useCallback)(async () => {
        try {
            setProjectsState({ inProgress: true });
            // if (process.env.NODE_ENV === "development") {
            //     await delayPromise(2000)
            //     throw new Error("AAAA" + new Date().getTime())
            // }
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                const customerProjects = await managementActor.getParticipantProjects();
                if ((0, ICCanisterUtils_1.isICRequestOk)(customerProjects)) {
                    const projectData = await getProjectsDataFromViews(customerProjects.ok, managementActor)
                        .then(value => {
                        return fillProjectsDataWithProjectState(value, actorsContext.getAnalyticsStoreActor);
                    });
                    if (isMounted()) {
                        setProjectsState({
                            inProgress: false,
                            loaded: true,
                            data: projectData,
                            isError: false
                        });
                    }
                }
                else {
                    setProjectsState({ inProgress: false });
                }
            }
            else {
                setProjectsState({ inProgress: false });
            }
        }
        catch (e) {
            if (process.env.NODE_ENV === "development") {
                console.error(e);
            }
            if (lodash_1.default.includes(e.message, "Invalid canister signature")) {
                console.log("Will logout...");
                authProviderContext.logout(authProviderContext.source);
                return;
            }
            if (isMounted()) {
                setProjectsState({
                    inProgress: false,
                    loaded: true,
                    error: e,
                    isError: true
                });
            }
        }
    }, [isMounted, actorsContext.getManagementActor, actorsContext.getAnalyticsStoreActor, authProviderContext.logout, authProviderContext.source]);
    const [projectsState, setProjectsState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), {
        inProgress: false,
        loaded: false,
        data: [],
        error: undefined,
        isError: false
    });
    const getActor = (0, use_custom_compare_1.useCustomCompareCallback)((projectApiKey) => {
        const projectAnalyticsReducerApiData = lodash_1.default.find(projectsState.data, value => {
            return lodash_1.default.isEqual(value.view.projectApiKey, projectApiKey);
        });
        return getActorFromProjectAnalyticsReducerApiData(actorsContext.getAnalyticsStoreActor, projectAnalyticsReducerApiData === null || projectAnalyticsReducerApiData === void 0 ? void 0 : projectAnalyticsReducerApiData.api, projectAnalyticsReducerApiData === null || projectAnalyticsReducerApiData === void 0 ? void 0 : projectAnalyticsReducerApiData.error);
    }, [projectsState.data, actorsContext.getAnalyticsStoreActor], (prevDeps, nextDeps) => lodash_1.default.isEqual(prevDeps, nextDeps));
    const getProjectData = (0, use_custom_compare_1.useCustomCompareCallback)((projectApiKey) => {
        const result = lodash_1.default.find(projectsState.data, value => {
            return lodash_1.default.isEqual(value.view.projectApiKey, projectApiKey);
        });
        return result;
    }, [projectsState.data], (prevDeps, nextDeps) => lodash_1.default.isEqual(prevDeps, nextDeps));
    return (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        projectsState,
        getActor,
        getProjectData,
        fetchAllProjects,
        createProject,
        renameProject
    }), [
        projectsState,
        getActor,
        getProjectData,
        fetchAllProjects,
        createProject,
        renameProject
    ], (prevDeps, nextDeps) => {
        const prevProjectsState = prevDeps[0];
        const nextProjectsState = nextDeps[0];
        const prevGetActor = prevDeps[1];
        const nextGetActor = nextDeps[1];
        const prevGetProjectData = prevDeps[2];
        const nextGetProjectData = nextDeps[2];
        const isProjectsStateEqual = lodash_1.default.isEqual(prevProjectsState, nextProjectsState);
        const isGetActorEqual = prevGetActor == nextGetActor;
        const isGetProjectDataEqual = prevGetProjectData == nextGetProjectData;
        const isEqual = isProjectsStateEqual
            && isGetActorEqual
            && isGetProjectDataEqual;
        return isEqual;
    });
}
exports.useProjectsProviderValue = useProjectsProviderValue;
